const videos = document.querySelectorAll('.player');

class Video {
  init() {
    videos.forEach( video => {
      this.addClass(video)
    })
  }

  addClass(elem) {
    // elem.parentNode.classList.add('video');
  }
}

export default new Video();
